import { render, staticRenderFns } from "./CommentsPreviewDialog.vue?vue&type=template&id=331a9c18&scoped=true&"
import script from "./CommentsPreviewDialog.vue?vue&type=script&lang=js&"
export * from "./CommentsPreviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./CommentsPreviewDialog.vue?vue&type=style&index=0&id=331a9c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331a9c18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VDialog})
